/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { Map, List, OrderedMap, Set} from 'immutable';
import * as Types from './types';
import { createSelector } from 'reselect';

export const summary = getterFromKeyPath(['summaries', 'current']);
export const summaries = getterFromKeyPath(['summaries', 'summaries']);
export const loading = getterFromKeyPath(['summaries', 'loading']);
export const description = getterFromKeyPath(['summaries', 'current', 'description']);
export const attributes = getterFromKeyPath(['summaries', 'current', 'attributes']);
export const hasSummary = getterFromKeyPath(['summaries', 'hasSummary']);
export const summaryFullyExpanded = getterFromKeyPath(['summaries', 'summaryFullyExpanded']);
export const enclaveClosedSourceMapping = getterFromKeyPath(['summaries', 'enclaveClosedSourceMapping']);

export const closedSourceEnclaveMapSet = createSelector(
  [enclaveClosedSourceMapping],
  (enclaveClosedSourceMapping: OrderedMap<any, any>) => {
    return enclaveClosedSourceMapping
      .reduce((finalSet = Set(), currentSource) => {
        return currentSource.size > 0 ?
          finalSet.concat(currentSource) : finalSet;
    }, Set());
  }
);

export const getSummary = (reportId: string) => {
  return createSelector(
    summaries,
    (summaries: Map<any, any>) => summaries.get(reportId, Types.Summary()),
  );
};


// WEBPACK FOOTER //
// ./src/app/modules/summaries/getters.js